import React from 'react'
import PropTypes from 'prop-types'
import { Multiple } from '~/components/common/AsyncSelect'

const MultipleAsyncSelect = ({
  field,
  form,
  forwardValues,
  revertValues,
  disabled,
  ...props
}) => (
  <Multiple
    {...field}
    values={forwardValues(field.value)}
    onChange={(v) => form.setFieldValue(field.name, revertValues(v))}
    disabled={disabled || !!form.values.__readOnly}
    {...props}
  />
)

MultipleAsyncSelect.defaultProps = {
  forwardValues: (v) => v,
  revertValues: (v) => v,
  disabled: false,
}

MultipleAsyncSelect.propTypes = {
  forwardValues: PropTypes.func,
  revertValues: PropTypes.func,
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  disabled: PropTypes.bool,
}

export default MultipleAsyncSelect
